// removed by extract-text-webpack-plugin
module.exports = {"update_available":"update_available__dINFz"};


//////////////////
// WEBPACK FOOTER
// ./components/update-available/style.scss
// module id = cGdW
// module chunks = 13